import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"

import { COMPARISON, GLOSSARY } from "./guideContent"
import { GuideSection } from "./guideParts"

export function CompareSection() {
  return (
    <GuideSection
      id="compare"
      eyebrow="Karşılaştırma"
      title="v1 ile farkı"
      lead="Tenant'ın ayarları (guidance, skill, aksiyon, bilgi bankası) iki motorda aynıdır; değişen, bunların nasıl kullanıldığıdır."
    >
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ borderRadius: 2 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 900, width: "24%" }}>Konu</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>v1</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>v2</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {COMPARISON.map((row) => (
              <TableRow key={row.topic}>
                <TableCell sx={{ fontWeight: 800 }}>{row.topic}</TableCell>
                <TableCell sx={{ color: "text.secondary" }}>{row.v1}</TableCell>
                <TableCell>{row.v2}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </GuideSection>
  )
}

export function GlossarySection() {
  return (
    <GuideSection
      id="glossary"
      eyebrow="Sözlük"
      title="Terimler"
      lead="Bu sayfada ve AI Logs'ta geçen kelimeler, sade dille."
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
          gap: 1.5
        }}
      >
        {GLOSSARY.map((item) => (
          <Paper
            key={item.term}
            variant="outlined"
            sx={{ p: 2, borderRadius: 2 }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 900 }}>
              {item.term}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.meaning}
            </Typography>
          </Paper>
        ))}
      </Box>
    </GuideSection>
  )
}
